import { Injectable } from '@angular/core';

import { ITheme } from '@interfaces/theme';
import { BehaviorSubject } from 'rxjs';
import { FirebaseService } from '../firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class ThemesService {

  themesSub: any;
  private themesSource = new BehaviorSubject<ITheme[]>(null);
  currentThemesSource = this.themesSource.asObservable();

  constructor(
    private firebaseService: FirebaseService,
  ) {}

  getThemesObs() {
    this.themesSub = this.firebaseService.getSnapshotObs(
      'themes', 'showInApp', true, this.themesSource, null, 'order', 'desc',
    );
  }

  async getTheme(themeId: string): Promise<ITheme> {
    const themeCollection = this.firebaseService.getCollection('themes');
    const theme = await this.firebaseService.getDocument(themeId, themeCollection);
    return theme as ITheme;
  }
}
